import { color } from '@upstox/upstox-ui';

export const oiCell: CSSFunction = () => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',
});

export const barContainer: CSSFunction<{ isCall: boolean }> = ({
  cssProps,
}) => {
  const { isCall } = cssProps;
  return {
    ...(!isCall && {
      justifyContent: 'flex-end',
      marginRight: '-8px',
    }),
    ...(isCall && {
      marginLeft: '-8px',
    }),
    position: 'absolute',
    ...(isCall ? {
      left: 0,
    } : {
      right: 0,
    }),
    width: '100%',
    zIndex: 0,
  };
};

export const labelContainer: CSSFunction = () => ({
  justifyContent: 'center',
  zIndex: 1,
});

export const topBar: CSSFunction<{
  variant: 'positive' | 'negative';
  isCall: boolean;
}> = ({ cssProps, theme }) => {
  const { variant = 'positive', isCall } = cssProps;

  return {
    backgroundColor: color(
      theme,
      variant === 'positive' ? 'data.positiveSubtle' : 'data.negativeSubtle',
    ),
    ...(isCall && {
      borderTopRightRadius: 8,
      borderBottomRightRadius: 8,
    }),
    ...(!isCall && {
      borderTopLeftRadius: 8,
      borderBottomLeftRadius: 8,
    }),
    height: 10,
    maxWidth: '100%',
    minWidth: 0,
  };
};
